// extracted by mini-css-extract-plugin
module.exports = {"container":"WaDqt0","content":"_3PrAvA","title":"_2C0HVU","subTitleContainer":"_2ZxtFf"};